module.exports = __webpack_public_path__ + "img/map-nav-orange.5f3e8290.svg";